import { useCoreService } from 'core/services/useCoreService';
import { createContext, useCallback, useEffect, useState } from 'react';
import { useDataFetcher } from 'shared/http';
import { Cuenta } from '../models/Cuenta';
import { SelectOption } from 'shared/form/models/SelectOption';
import { TipoCuenta } from '../models/SearchCuentasRequests';

export const ALL_ACCOUNTS_SELECT_OPTION: SelectOption<Cuenta> = {
  label: 'Todas las cuentas',
  value: undefined,
};

interface ICuentaSelectorContext {
  cuentaList: SelectOption<Cuenta>[];
  cuentaUsuario: Cuenta;
  isLoading: boolean;
  searchAccounts: (tipoCuenta?: string) => void;
}

export const CuentaSelectorContext = createContext<ICuentaSelectorContext>({
  cuentaList: [],
  cuentaUsuario: null,
  isLoading: true,
  searchAccounts: () => null,
});

export const CuentaSelectorProvider = ({ children }) => {
  const [cuentaList, setCuentaListRequest] = useDataFetcher<SelectOption<Cuenta>[]>([]);
  const [cuentaUsuario, setCuentaUsuario] = useState<Cuenta>(null);
  const coreService = useCoreService();

  const searchAccounts = useCallback(
    (tipoCuenta?: TipoCuenta) => {
      const responseMapper = (lista: Cuenta[]): SelectOption<Cuenta>[] => {
        if (lista == null) {
          return [];
        }
        setCuentaUsuario(lista[0]);
        const result = lista.map((cuenta) => ({
          value: cuenta,
          label: cuenta.label,
        }));
        return result;
      };

      setCuentaListRequest(() =>
        coreService
          .getVisibleAccounts({ tipoCuenta, cuentasHuerfanas: false })
          .then((response) => responseMapper(response)),
      );
    },
    [coreService, setCuentaListRequest],
  );

  useEffect(() => searchAccounts(), [searchAccounts]);

  const contextValue: ICuentaSelectorContext = {
    cuentaList: cuentaList.data,
    isLoading: cuentaList.isLoading,
    cuentaUsuario,
    searchAccounts,
  };

  return (
    <CuentaSelectorContext.Provider value={contextValue}>
      {children}
    </CuentaSelectorContext.Provider>
  );
};
